import assert from './assert'

export const warehousePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/overview`
}

export const warehouseConnectPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])

  const url = `/${args.workspaceSlug}/warehouses/${args.warehouseId}/connect`

  if (args.bitoolSlug) {
    return `${url}/${args.bitoolSlug}`
  }

  return url
}

export const warehouseSettingsPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings`
}

export const warehouseSettingsConnectionPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${
    args.warehouseId
  }/settings/connection`
}

export const warehouseSettingsSyncPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/settings/sync`
}

export const warehouseSettingsSyncSchedulePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${
    args.warehouseId
  }/settings/sync-schedule`
}

export const warehouseSettingsMaintenancePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${
    args.warehouseId
  }/settings/maintenance`
}

export const warehouseHistoryPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sync`
}

export const warehouseHistorySourcePath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sync/${
    args.sourceId
  }`
}

export const warehouseHistorySourceRunPath = args => {
  assert(args, ['workspaceSlug', 'warehouseId', 'sourceId', 'runId'])
  return `/${args.workspaceSlug}/warehouses/${args.warehouseId}/sync/${
    args.sourceId
  }/${args.runId}`
}
